import Cookies from "js-cookie";

export default function persistAuthToken(id, token, expires) {
  const secure = process.env.NODE_ENV === "production";
  return () => {
    const authObject = { id, token, expires };
    Cookies.set("auth", authObject, { expires, secure });
  };
}
